import Route from '@ember/routing/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'

export class MsStandardsPerformanceRoute extends Route {
  queryParams = {
    contentLevel: {
      replace: true,
      refreshModel: false,
    },
    sort: {
      replace: true,
      refreshModel: false,
    },
    pageNumber: {
      replace: true,
      refreshModel: false,
    },
    perPage: {
      replace: true,
      refreshModel: false,
    },
  }

  model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students

    return { uiScope, scopedStudents, period }
  }
}

export default MsStandardsPerformanceRoute
